import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import AutoComp from '../components/AutoComp'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrTableReg from '../components/FrTableReg'
import Dialog from '@material-ui/core/Dialog';
import { colors } from '../utils/vars'
import { upload } from 'react-icons-kit/fa/upload'
import { Icon } from 'react-icons-kit'

import api from '../services/api'
import $ from 'jquery'
import { getUserCode, paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function RegDocumentos(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [arquivo, setArquivo] = useState('')
  const [arq, setArq] = useState('')
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboAtivo, setComboAtivo] = useState([{ value: 'S', display: 'Ativo' }, { value: 'N', display: 'Inativo' },])
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboCto, setComboCto] = useState([{ value: '', display: '' }])
  const [cli, setCli] = useState()
  const [cto, setCto] = useState()
  const [dataDoc, setDataDoc] = useState([{ pk: 0, arquivo: '' }])
  const [showModalDoc, setShowModalDoc] = useState(false)
  const cliInitialized = useRef(false)

  const columnsDoc = [
    { id: 'arquivo', numeric: false, label: 'Arquivo', align: 'left', minWidth: 400 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Documentação Cliente', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Documentação Cliente', 'Inclusao'))
      }


      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/documentos?pk_dcl=' + query.codigo).then(async r => {
          if (r.data[0]) {
            setData(r.data[0])
            let arquivos = r.data[0].arquivos
            if (typeof arquivos === 'string') {
              try { arquivos = JSON.parse(arquivos) } catch (e) { arquivos = [] }
            }
            if (Array.isArray(arquivos) && arquivos.length > 0)
              setDataDoc(arquivos.map((a, i) => ({ pk: i + 1, arquivo: a.arquivo })))
            if (r.data[0].fk_cli) {
              setCli(r.data[0].fk_cli)
              setComboCli(await api.getComboDataWhere('clientes', '?nome=' + r.data[0].nome))
            }
            if (r.data[0].fk_cto) {
              setCto(r.data[0].fk_cto)
              setComboCto(await api.getComboDataWhere('contratos', r.data[0].fk_cli ? '?fk_cli=' + r.data[0].fk_cli : '?pk_cto=' + r.data[0].fk_cto))
            }
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchCli = async () => {
      let nomecli = ''
      if (cli > 0) {
        await api.get('/clientes?pk_cli=' + cli).then((r) => {
          if (r.data[0]) nomecli = r.data[0].nome
        })
        setComboCto(await api.getComboDataWhere('contratos', '?fk_cli=' + cli))
      } else {
        setComboCto(await api.getComboDataWhere('contratos', ''))
      }

      // ao trocar de cliente, limpa o contrato selecionado (exceto no carregamento inicial da edicao)
      if (cliInitialized.current) {
        setCto('')
      }
      cliInitialized.current = true

      setData((prev) => ({ ...prev, fk_cli: cli || '', nomecli }))
    }
    fetchCli()
  }, [cli])

  useEffect(() => {
    setData((prev) => ({ ...prev, fk_cto: cto || '', nomecto: cto > 0 ? String(cto) : '' }))
  }, [cto])

  function consistData(data) {
    let required = [
      'descricao'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)
    })

    if (dataDoc.filter((d) => d.pk > 0 && (d.file || d.arquivo)).length === 0)
      errors.push('documento(s)')

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.fk_usu = getUserCode()
        let formData = new FormData();
        try {
          formData.append('fk_usu', auxValues.fk_usu)
          formData.append('fk_cto', auxValues.fk_cto || '')
          formData.append('fk_cli', auxValues.fk_cli || '')
          formData.append('ativo', auxValues.ativo)
          formData.append('titulo', auxValues.titulo)
          formData.append('descricao', auxValues.descricao)
          if (updateType)
            formData.append('pk_dcl', auxValues.pk_dcl)

          // novos arquivos selecionados nesta sessão
          dataDoc
            .filter((d) => d.pk > 0 && d.file)
            .forEach((d) => formData.append('documentos', d.file, d.arquivo))

          // arquivos ja salvos que devem ser mantidos (edicao)
          formData.append(
            'arquivos_mantidos',
            JSON.stringify(dataDoc.filter((d) => d.pk > 0 && !d.file).map((d) => d.arquivo))
          )
        } catch {

        }
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/documentos/edit', formData).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/documentos/add', formData).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  const selectFile = (e) => {
    e.preventDefault();
    $('#html').click();
  }

  const handleFile = (e) => {
    e.preventDefault()
    let file = e.target.files[0];
    if (file) {
      setArq(file)
      setArquivo(file.name)
    } else {
      setArq(null)
      setArquivo('Nenhum arquivo selecionado')
    }

  }

  function incluiDoc(e) {
    e.preventDefault();
    setArq(null)
    setArquivo('')
    setShowModalDoc(true)
  }

  function escondeModalDoc(e) {
    e.preventDefault();
    setArq(null)
    setArquivo('')
    setShowModalDoc(false)
  }

  function confirmaDoc(e) {
    e.preventDefault();
    if (!arq) {
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>Atenção</h2>`,
        text: 'Selecione um arquivo!',
        icon: 'warning',
      })
      return
    }

    let pk = Math.max(0, ...dataDoc.map((d) => d.pk || 0)) + 1
    let item = [{ pk, arquivo: arq.name, file: arq }]

    dataDoc.forEach((d) => {
      if (d.pk > 0)
        item.push({ pk: d.pk, arquivo: d.arquivo, file: d.file })
    })

    setDataDoc(item)
    setArq(null)
    setArquivo('')
    setShowModalDoc(false)
  }



  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Documentos</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <AutoComp
            value={data.nomecli || ''}
            valor={cli}
            width={330}
            tabela={'clientes'}
            chave={'nome'}
            name="fk_cli"
            id="fk_cli"
            label='Cliente'
            data={comboCli}
            setValue={setCli}
            form={'regForm'}
          />
          <AutoComp
            value={data.nomecto || ''}
            valor={cto}
            width={170}
            tabela={'contratos'}
            chave={'pk_cto'}
            name="fk_cto"
            id="fk_cto"
            label='Contrato'
            data={comboCto}
            setValue={setCto}
            where={cli > 0 ? '&fk_cli=' + cli : ''}
            form={'regForm'}
          />
          <br />

          <FrTextInput
            value={data.titulo || ''}
            style={{ width: 330 }}
            name="titulo"
            id="titulo"
            color="#389492"
            label="Titulo"
            variant="outlined"
            size="small"
            onChange={handleChange}
          />
          <FrTextInput
            value={data.descricao || ''}
            style={{ width: 330 }}
            name="descricao"
            id="descricao"
            color="#389492"
            label="Descrição"
            variant="outlined"
            size="small"
            onChange={handleChange}
          />

          <FrSelect
            value={data.ativo || ''}
            style={{ width: 170 }}
            name="ativo"
            id="ativo"
            label='Ativo'
            data={comboAtivo}
            onChange={handleChange}
          />
          <br />
          <div className="defaultHeader">
            <h3>Documentos</h3>
          </div>

          <div className="xButtons">
            <button className="botao" onClick={incluiDoc}> {'Incluir'} </button>
          </div>
          <div>
            <br />
            <div className="tableDiv">
              <FrTableReg
                rowsPerPage={5}
                dense
                setDataGrid={setDataDoc}
                regName="documentos"
                columns={columnsDoc}
                searched={false}
                codeName="pk"
                page={''}
                data={dataDoc}
              />
            </div>
          </div>

        </form>

        <Dialog aria-labelledby="simple-dialog-title" open={showModalDoc} fullWidth={true} maxWidth={'sm'}>
          <div className="defaultHeader">
            <h3>Incluir Documento</h3>
          </div>
          <div className="modalContent">
            <input
              type="file"
              id="html"
              accept=".png, .jpeg, .jpg, .doc, .pdf"
              onChange={handleFile}
              style={{ display: 'none' }}
            />
            <FrTextInput
              value={arquivo || ''}
              name="arquivo"
              id="arquivo"
              color="#528b46"
              label="Arquivo"
              variant="outlined"
              size="small"
              disabled
              style={{ width: 300 }}
            />
            <button type="button" className="selectFileButton" onClick={selectFile}>
              Escolher Arquivo
            </button>
          </div>
          <div className="FrModalFooter">
            <div className="FrModalButtonsDiv">
              <button onClick={confirmaDoc}> Confirmar</button>
              <button onClick={escondeModalDoc}> Sair </button>
            </div>
          </div>
        </Dialog>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RegDocumentos;
